// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Same look as CompleteWithSubtasksModal; stacked above LeadWorkModal (z-index 1000)
   because Disqualify can be triggered from inside it. */
.DisqualifyLeadModal-module__modalOverlay___xBpaF {
  position: fixed;
  inset: 0;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.35);
}

.DisqualifyLeadModal-module__modalBackdrop___vcf8g {
  position: absolute;
  inset: 0;
  border: none;
  padding: 0;
  background: transparent;
}

.DisqualifyLeadModal-module__modalCard___gai9A {
  position: relative;
  width: 100%;
  max-width: 440px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}

.DisqualifyLeadModal-module__modalHeader___gJCaB {
  padding: 14px 16px;
  border-bottom: 1px solid #e5e7eb;
}

.DisqualifyLeadModal-module__modalTitle___AePDI {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}

.DisqualifyLeadModal-module__modalBody___BAl2r {
  padding: 16px;
}

.DisqualifyLeadModal-module__modalCopy___KB4BF {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: #4b5563;
}

.DisqualifyLeadModal-module__modalCopyStrong___te3kF {
  font-weight: 600;
  color: #111827;
}

.DisqualifyLeadModal-module__formGrid___DpexP {
  display: grid;
  gap: 12px;
  margin-top: 16px;
}

.DisqualifyLeadModal-module__field___UIqg5 {
  display: grid;
  gap: 5px;
  color: #374151;
  font-size: 12px;
  font-weight: 600;
}

.DisqualifyLeadModal-module__field___UIqg5 input,
.DisqualifyLeadModal-module__field___UIqg5 select {
  width: 100%;
  min-height: 36px;
  box-sizing: border-box;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 7px 9px;
  background: #ffffff;
  color: #111827;
  font: inherit;
  font-weight: 400;
}

.DisqualifyLeadModal-module__field___UIqg5 select:disabled {
  background: #f3f4f6;
  color: #9ca3af;
}

.DisqualifyLeadModal-module__required___iSxXk {
  color: #b91c1c;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
}

.DisqualifyLeadModal-module__validationError___IrcSV {
  color: #b91c1c;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
}

.DisqualifyLeadModal-module__modalActions___nxwii {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 16px 16px;
  border-top: 1px solid #e5e7eb;
}

.DisqualifyLeadModal-module__modalActionButton___fADFg {
  min-width: 88px;
  padding: 7px 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.DisqualifyLeadModal-module__modalSecondaryAction___XOl7n {
  border: 1px solid #d1d5db;
  background: #ffffff;
  color: #4b5563;
}

.DisqualifyLeadModal-module__modalDangerAction___mmPrq {
  border: none;
  background: #b91c1c;
  color: #fef2f2;
}

.DisqualifyLeadModal-module__modalActionButton___fADFg:disabled {
  cursor: default;
  opacity: 0.6;
}

@media (max-width: 640px) {
  .DisqualifyLeadModal-module__modalCard___gai9A {
    max-width: 100%;
  }
  .DisqualifyLeadModal-module__modalActions___nxwii {
    flex-direction: column-reverse;
  }
  .DisqualifyLeadModal-module__modalActionButton___fADFg {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/DisqualifyLeadModal/DisqualifyLeadModal.module.scss"],"names":[],"mappings":"AAAA;wDAAA;AAEA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,+BAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,2CAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gCAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;;EAEE,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,uBAAA;EACA,6BAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,yBAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;AACF;;AAEA;EACE;IACE,eAAA;EACF;EAEA;IACE,8BAAA;EAAF;EAGA;IACE,WAAA;EADF;AACF","sourcesContent":["/* Same look as CompleteWithSubtasksModal; stacked above LeadWorkModal (z-index 1000)\n   because Disqualify can be triggered from inside it. */\n.modalOverlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1001;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  background: rgba(0, 0, 0, 0.35);\n}\n\n.modalBackdrop {\n  position: absolute;\n  inset: 0;\n  border: none;\n  padding: 0;\n  background: transparent;\n}\n\n.modalCard {\n  position: relative;\n  width: 100%;\n  max-width: 440px;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.18);\n  overflow: hidden;\n}\n\n.modalHeader {\n  padding: 14px 16px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.modalTitle {\n  font-size: 16px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.modalBody {\n  padding: 16px;\n}\n\n.modalCopy {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #4b5563;\n}\n\n.modalCopyStrong {\n  font-weight: 600;\n  color: #111827;\n}\n\n.formGrid {\n  display: grid;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.field {\n  display: grid;\n  gap: 5px;\n  color: #374151;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.field input,\n.field select {\n  width: 100%;\n  min-height: 36px;\n  box-sizing: border-box;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  padding: 7px 9px;\n  background: #ffffff;\n  color: #111827;\n  font: inherit;\n  font-weight: 400;\n}\n\n.field select:disabled {\n  background: #f3f4f6;\n  color: #9ca3af;\n}\n\n.required {\n  color: #b91c1c;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 500;\n}\n\n.validationError {\n  color: #b91c1c;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 500;\n}\n\n.modalActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 12px 16px 16px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.modalActionButton {\n  min-width: 88px;\n  padding: 7px 12px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.modalSecondaryAction {\n  border: 1px solid #d1d5db;\n  background: #ffffff;\n  color: #4b5563;\n}\n\n.modalDangerAction {\n  border: none;\n  background: #b91c1c;\n  color: #fef2f2;\n}\n\n.modalActionButton:disabled {\n  cursor: default;\n  opacity: 0.6;\n}\n\n@media (max-width: 640px) {\n  .modalCard {\n    max-width: 100%;\n  }\n\n  .modalActions {\n    flex-direction: column-reverse;\n  }\n\n  .modalActionButton {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `DisqualifyLeadModal-module__modalOverlay___xBpaF`,
	"modalBackdrop": `DisqualifyLeadModal-module__modalBackdrop___vcf8g`,
	"modalCard": `DisqualifyLeadModal-module__modalCard___gai9A`,
	"modalHeader": `DisqualifyLeadModal-module__modalHeader___gJCaB`,
	"modalTitle": `DisqualifyLeadModal-module__modalTitle___AePDI`,
	"modalBody": `DisqualifyLeadModal-module__modalBody___BAl2r`,
	"modalCopy": `DisqualifyLeadModal-module__modalCopy___KB4BF`,
	"modalCopyStrong": `DisqualifyLeadModal-module__modalCopyStrong___te3kF`,
	"formGrid": `DisqualifyLeadModal-module__formGrid___DpexP`,
	"field": `DisqualifyLeadModal-module__field___UIqg5`,
	"required": `DisqualifyLeadModal-module__required___iSxXk`,
	"validationError": `DisqualifyLeadModal-module__validationError___IrcSV`,
	"modalActions": `DisqualifyLeadModal-module__modalActions___nxwii`,
	"modalActionButton": `DisqualifyLeadModal-module__modalActionButton___fADFg`,
	"modalSecondaryAction": `DisqualifyLeadModal-module__modalSecondaryAction___XOl7n`,
	"modalDangerAction": `DisqualifyLeadModal-module__modalDangerAction___mmPrq`
};
module.exports = ___CSS_LOADER_EXPORT___;
